import PropTypes from "prop-types"
import React, {forwardRef, useImperativeHandle, useMemo, useRef, useState} from "react"
import {Badge, Col, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip} from "reactstrap"
import {apiBuscarGruposCardapio} from "../../helpers/backend_helper"
import ListDataTable from "../../components/Common/list-data-table"
import {Link} from "react-router-dom"
import {AvForm} from "availity-reactstrap-validation"
import {Box, TextField} from "@mui/material"
import {describeDateTime, removeHour} from "../../helpers/utils"
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider"
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import "react-datepicker/dist/react-datepicker.css"
import {DatePicker} from "@mui/x-date-pickers/DatePicker"
import ptBR from "date-fns/locale/pt-BR"
import {ptBR as ptBRDatePickers} from '@mui/x-date-pickers'
import {registerLocale, setDefaultLocale} from "react-datepicker"
const ptBRLocale = ptBRDatePickers.components.MuiLocalizationProvider.defaultProps.localeText

registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const GruposTable = forwardRef((props, refFather) => {

    const ref = useRef()

    const { filters, columns, multiplasEmpresas, usePermissionRemove, usePermissionEdit, removerGrupoCardapio, navegarEditarGrupoCardapio } = props

    const [data, setData] = useState([])
    const [modalRemove, setModalRemove] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState()

    useImperativeHandle(refFather, () => ({
        search() {
            ref?.current?.search()
        }
    }))

    const showConfirmDelete = item => {
        setItemSelecionado(item)
        setModalRemove(true)
    }

    const remover = () => {
        removerGrupoCardapio(itemSelecionado)
        setModalRemove(false)
    }

    const getBadgeElement = (cell) => {
        return <Badge
            className={"font-size-12 badge-soft-" + (cell.getValue() == 'S' ? 'primary higher' : 'soft-dark')}
            color={cell.getValue() == 'S' ? 'primary higher' : 'soft-dark'}
            pill
        >
            {cell.getValue() == 'S' ? 'Sim' : 'Não'}
        </Badge>
    }

    const colunas = useMemo(() => columns ||
        [
            { header: "ID Cloud", accessorKey: "id", size: 80, enableHiding: false,
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },
            { header: "Empresa", accessorKey: "empresa.Fantasia", size: 180, filterFn: 'contains',
                accessorFn: (row) => row.empresa?.Fantasia || ''
            },
            { header: "Código", accessorKey: "Codigo", size: 80},
            { header: "Descrição", accessorKey: "Descricao", size: 120, filterFn: 'contains'},
            { header: "Subgrupo", accessorKey: "SubGrupo", size: 90,
                filterVariant: 'checkbox',
                Cell: ({cell}) => (
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '1rem',}}>
                        {getBadgeElement(cell)}
                    </Box>),
            },
            { header: "Visível Desktop", accessorKey: "Desktop_Visivel", size: 150,
                filterVariant: 'checkbox',
                Cell: ({cell}) => (
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '1rem',}}>
                        {getBadgeElement(cell)}
                    </Box>),
            },
            { header: "Visível no Mobile", accessorKey: "Mobile_Visivel", size: 150,
                filterVariant: 'checkbox',
                Cell: ({cell}) => (
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '1rem',}}>
                        {getBadgeElement(cell)}
                    </Box>),
            },
            { header: "Visível no Infinitifood", accessorKey: "Infinitifood_Visivel", size: 200,
                filterVariant: 'checkbox',
                Cell: ({cell}) => (
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '1rem',}}>
                        {getBadgeElement(cell)}
                    </Box>),
            },
            { header: "Visível no Menu Digital", accessorKey: "MenuDigital_Visivel", size: 200,
                filterVariant: 'checkbox',
                Cell: ({cell}) => (
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '1rem',}}>
                        {getBadgeElement(cell)}
                    </Box>),
            },
            { header: "Qtde. itens", accessorKey: "itensCount", size: 90, enableColumnFilter: false,},
            { header: "Qtde. observações", accessorKey: "observacoesCount", size: 180, enableColumnFilter: false,},
            { header: 'Última alteração', size: 180,
                Cell: ({cell}) => describeDateTime(cell?.getValue()),
                accessorFn: (row) => new Date(row.AltData),
                accessorKey: 'AltData',
                sortingFn: 'datetime',
                Filter: ({column}) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={ptBRLocale}>
                        <DatePicker
                            onChange={(newValue) => {
                                if (newValue) {
                                    newValue = removeHour(newValue, false)
                                }
                                column.setFilterValue(newValue)
                            }}
                            inputFormat="dd/MM/yyyy"
                            componentsProps={{
                                actionBar: {
                                    actions: ['accept', 'clear'],
                                },
                            }}
                            value={column.getFilterValue() ? new Date(column.getFilterValue()) : null}
                            views={['year', 'month', 'day']}
                            renderInput={(props) => <TextField {...props} variant="standard"/>}
                        />
                    </LocalizationProvider>
                ),
            },
        ], [])

    return (
        <React.Fragment>
            <ListDataTable
                ref={ref}
                searchFn={params => apiBuscarGruposCardapio(params)}
                advancedFilters={filters}
                columns={colunas}
                data={data}
                setData={setData}
                columnVisibility={{
                    'empresa.Fantasia': multiplasEmpresas,
                    Desktop_Visivel: false,
                    Mobile_Visivel: false,
                    Infinitifood_Visivel: false,
                    MenuDigital_Visivel: false
                }}
                enableRowActions={true}
                defaultSorting={[{
                    id: 'Ordem',
                    desc: false,
                }, {
                    id: 'id',
                    desc: true,
                }]}
                renderRowActions={(row, table) =>
                    (<Box sx={{display: 'flex', gap: '1rem'}}>
                        <Link to="#" className="text-primary">
                            <i className="mdi mdi-eye font-size-18 ms-1" id="viewtooltip"
                               onClick={e => navegarEditarGrupoCardapio(row.original)}
                               title="Visualizar"
                            />
                        </Link>
                        {usePermissionEdit && <Link to="#" className="text-primary">
                            <i className="mdi mdi-pencil font-size-18 ms-1" id="edittooltip"
                                onClick={e => navegarEditarGrupoCardapio(row.original)}
                               title="Editar"
                            />
                        </Link>}
                        {usePermissionRemove && <Link to="#" className="text-danger">
                            <i className="mdi mdi-delete font-size-18" id="btnDelete"
                               onClick={() => showConfirmDelete(row.original)} title="Remover"/>
                        </Link>}
                    </Box>)
                }
            />
            <Modal isOpen={modalRemove}>
                <ModalHeader tag="h4">Confirmação</ModalHeader>
                <ModalBody>
                    <AvForm onValidSubmit={(e, v) => {
                        remover()
                    }}>
                        <Row form>
                            <Col className="col-12">
                                Deseja realmente remover esse registro?
                            </Col>
                        </Row>
                        <Row style={{paddingTop: 10}}>
                            <Col>
                                <div className="text-right">
                                    <button type="submit" className="btn btn-success save-event">
                                        Confirmar
                                    </button>
                                    <button type="button" className="btn btn-light ms-2"
                                            onClick={e => setModalRemove(false)}>
                                        Cancelar
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </AvForm>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
})

export default GruposTable

GruposTable.propTypes = {
    filters: PropTypes.array,
    columns: PropTypes.array,
    multiplasEmpresas: PropTypes.bool,
    usePermissionRemove: PropTypes.bool,
    usePermissionEdit: PropTypes.bool,
    history: PropTypes.any,
    navegarEditarGrupoCardapio: PropTypes.func,
    removerGrupoCardapio: PropTypes.func,
}
